import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import LegacyFilterToolbar, {
  LEGACY_FILTER_INPUT_CLASS,
} from "components/Common/LegacyFilterToolbar";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Row,
} from "reactstrap";

import CommonTable from "components/Common/TableContainer";
import { AsyncClientSelect, AsyncUserSelect } from "components/Common/AsyncSearchSelects";
import {
    applyClientAsyncFilterOptionToFormState,
    applyUserAsyncFilterOptionToFormState,
    buildClientAsyncFilterInitialOption,
    buildUserAsyncFilterInitialOption,
    getClientAsyncFilterLabelFieldKey,
    getUserAsyncFilterLabelFieldKey,
    normalizeMetadataFilterDateForApi,
} from "helpers/metadataFilterHelpers";
import { submitUserClientActivityReportFilterData } from "model/UserClientActivityReportModel";
import dayjs from "dayjs";

const UserClientActivityReport = () => {
    const [filterForm, setFilterForm] = useState({
        clientId: "",
        [getClientAsyncFilterLabelFieldKey()]: "",
        userId: "",
        [getUserAsyncFilterLabelFieldKey()]: "",
        fromDate: "",
        toDate: "",
    });
    const [reportData, setReportData] = useState([]);

    const columns = [
        { Header: "S.N.", accessor: "sn" },
        { Header: "User", accessor: "user" },
        { Header: "Assign Date", accessor: "assignDate" },
        { Header: "UnAssign Date", accessor: "unAssignDate" },
        { Header: "Expectation", accessor: "expectation" },
        { Header: "Cur. Pipeline", accessor: "curPipeline" },
    ];

    const formatDate = (value) => {
        if (!value) return "";
        const parsed = dayjs(value);
        return parsed.isValid() ? parsed.format("MM-DD-YYYY") : value;
    };

    const filteredData = useMemo(() => reportData, [reportData]);

    const getUserClientActivityList = async () => {
        if (!filterForm?.clientId) {
            setReportData([]);
            return;
        }
        const payload = {
            clientId: filterForm?.clientId || "",
            userId: filterForm?.userId || null,
            dateFrom: normalizeMetadataFilterDateForApi(filterForm?.fromDate),
            dateTo: normalizeMetadataFilterDateForApi(filterForm?.toDate),
        };
        const response = await submitUserClientActivityReportFilterData(payload);
        const responseData = response?.data || {};
        const records = Array.isArray(responseData?.data)
            ? responseData?.data
            : Array.isArray(responseData?.records)
                ? responseData?.records
                : Array.isArray(responseData)
                    ? responseData
                    : [];
        const mappedData = (Array.isArray(records) ? records : []).map((item, idx) => ({
            ...item,
            sn: item?.serialNumber || item?.sn || item?.sN || idx + 1,
            user: item?.userName || item?.user || item?.name || "",
            assignDate: formatDate(item?.assignDateIso || item?.assignDate || item?.assignOn || ""),
            unAssignDate: formatDate(item?.unassignDateIso || item?.unAssignDate || item?.unassignedDate || ""),
            expectation: item?.expectation || "-",
            curPipeline: item?.currentPipeline || item?.curPipeline || item?.pipeline || "-",
        }));
        setReportData(mappedData);
    };

    const handleFilterFieldChange = (e) => {
        const { name, value } = e.target;
        setFilterForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Card>
                        <CardBody>
                            <h5 className="fw-bold mb-3">User Client Activity Report</h5>
                            <hr />

                            <LegacyFilterToolbar className="w-100">
                            <Row className="metadata-filter-toolbar__row g-2 g-md-3 align-items-end">
                                <Col xs="12" md="6" lg={3}>
                                    <span className="manage-user-filter-label">Client</span>
                                    <AsyncClientSelect
                                        key={`user-client-activity-client-${filterForm?.clientId || ""}`}
                                        pageName="ReportFiltered"
                                        value={filterForm?.clientId || ""}
                                        initialOption={buildClientAsyncFilterInitialOption(
                                            filterForm?.clientId,
                                            filterForm[getClientAsyncFilterLabelFieldKey()]
                                        )}
                                        onChange={(option) =>
                                            setFilterForm((prev) =>
                                                applyClientAsyncFilterOptionToFormState(prev, option)
                                            )
                                        }
                                        placeholder="Select Client"
                                    />
                                </Col>
                                {/* <Col xs="12" md="6" lg={3}>
                                    <span className="manage-user-filter-label">User</span>
                                    <AsyncUserSelect
                                        key={`user-client-activity-user-${filterForm?.userId || ""}`}
                                        pageName="UserClientActivityReport"
                                        value={filterForm?.userId || ""}
                                        initialOption={buildUserAsyncFilterInitialOption(
                                            filterForm?.userId,
                                            filterForm[getUserAsyncFilterLabelFieldKey()]
                                        )}
                                        onChange={(option) =>
                                            setFilterForm((prev) =>
                                                applyUserAsyncFilterOptionToFormState(prev, option)
                                            )
                                        }
                                        placeholder="Select User"
                                    />
                                </Col>
                                <Col xs="12" md="6" lg={2}>
                                    <span className="manage-user-filter-label">From date</span>
                                    <Input
                                        type="date"
                                        name="fromDate"
                                        className={LEGACY_FILTER_INPUT_CLASS}
                                        value={filterForm?.fromDate || ""}
                                        onChange={handleFilterFieldChange}
                                    />
                                </Col>
                                <Col xs="12" md="6" lg={3}>
                                    <span className="manage-user-filter-label">To date</span>
                                    <Input
                                        type="date"
                                        name="toDate"
                                        className={LEGACY_FILTER_INPUT_CLASS}
                                        value={filterForm?.toDate || ""}
                                        onChange={handleFilterFieldChange}
                                    />
                                </Col> */}

                                <Col xs="12" md="6" lg={2}>
                                    <span className="manage-user-filter-label" aria-hidden="true">&nbsp;</span>
                                    <Button
                                        color="primary"
                                        className="w-100 manage-user-search-btn"
                                        onClick={getUserClientActivityList}
                                    >
                                        <i className="fa fa-search me-1" aria-hidden="true" />
                                        Search
                                    </Button>
                                </Col>

                            </Row>
                            </LegacyFilterToolbar>
                            <CommonTable columns={columns} data={filteredData} isActionRequired={false} />
                        </CardBody>
                    </Card>


                </Container>
            </div>
        </React.Fragment>
    );
};

UserClientActivityReport.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(UserClientActivityReport);
